<template>
	<v-container>
		<div v-if="volunteers.length === 0" class="ml-4">
			<!--			Udział wolontariuszy nie jest przewidziany.-->
		</div>

		<div v-else>
			<h2>Wolontariusze</h2>
			<div v-for="(v, index) in volunteers" :key="index" class="mt-2">
				<v-layout row>
					<h4 class="mr-2">{{1+index}}.</h4>
					{{getVolunteerInfo(v.volunteerCode)}}
				</v-layout>
				<v-layout row v-for="(vt, vtIndex) in v.volunteeringTerms" :key="vtIndex">
					<v-layout row class="ml-5">
						<egranty-date-picker
							label="Zadeklarowany początek wolontariatu"
							:disabled="true"
							v-model="vt.projectStartDate"
						></egranty-date-picker>
						<egranty-date-picker
							label="Zadeklarowany koniec wolontariatu"
							:disabled="true"
							v-model="vt.projectEndDate"
						></egranty-date-picker>
					</v-layout>

					<v-layout row class="ml-5">
						<egranty-date-picker
							label="Rzeczywisty początek wolontariatu"
							v-model="vt.realStartDate"
							@input="sync"
							:disabled="readonly"
						></egranty-date-picker>
						<egranty-date-picker
							label="Rzeczywisty koniec wolontariatu"
							v-model="vt.realEndDate"
							@input="sync"
							:disabled="readonly"
						></egranty-date-picker>
					</v-layout>
				</v-layout>
			</div>
		</div>
	</v-container>
</template>

<script>
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";
	import {Volunteer} from "@/api/generated/Volunteer";

	export default {
		name: "FinalReportVolunteers",
		components: {EgrantyDatePicker},
		data() {
			return {
				projectId: this.$route.params.projectId,
				loadedVolunteers: []
			};
		},

		methods: {

			findCachedVolunteerInfo(code) {
				return this.loadedVolunteers.find(x => x.code === code);
			},

			getVolunteerInfo(code) {
				if (!this.findCachedVolunteerInfo(code)) {
					this.loadedVolunteers.push({code: code, data: {}});
					Volunteer.getVolunteerOfferData(
						this,
						code,
						(response) => this.findCachedVolunteerInfo(code).data = response
					);
				}
				let cachedData = this.findCachedVolunteerInfo(code).data;
				if (!cachedData){
					return "";
				}

				return cachedData.name + " " + cachedData.surname + " (" + cachedData.email + ")";
			},

			sync() {
				this.$emit('volunteers', this.volunteers);
			}
		},

		props: {
			volunteers: {},
			readonly: {}
		}
	};
</script>

<style scoped>

</style>
